import { useState } from 'react';

interface ILocalStorageState<T> {
  value: T | undefined;
  setValue: (value: T) => void;
  removeValue: () => void;
}

export const useLocalStorage = <T>(key: string, initialValue?: T): ILocalStorageState<T> => {
  const [storedValue, setStoredValue] = useState<T | undefined>(() => {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      return initialValue;
    }
  });

  const setValue = (value: T) => {
    try {
      const valueToStore = value instanceof Function ? value(storedValue) : value;

      setStoredValue(valueToStore);
      localStorage.setItem(key, JSON.stringify(valueToStore));
    } catch (error) {
      console.error(error);
    }
  };

  const removeValue = () => {
    try {
      setStoredValue(undefined);
      localStorage.removeItem(key);
    } catch (error) {
      console.error(error);
    }
  };

  return { value: storedValue, setValue, removeValue };
};
